module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-23.e5f78d87.svg";